import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dilution-calculator',
  component: () => import('../../routes/DilutionCalculator.svelte'),
  card: {
    id: 'dilution-calculator',
    title: 'Dilution Calculator',
    description: 'Calculate solution dilution using the M₁V₁ = M₂V₂ formula. Find the volume of stock solution needed or the final concentration.',
    icon: 'science',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/dilution-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Dilution Calculator – M₁V₁ = M₂V₂ Solution Dilution Calculator',
    description:
      'Free dilution calculator using the M₁V₁ = M₂V₂ formula. Calculate how much stock solution to use, or find the final concentration. Ideal for chemistry labs, pharmacies, and IV preparation.',
  },
};

export default meta;
